module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "ch01"
    }
  })]), _c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER ONE")]), _c('br'), _vm._v("GETTING STARTED")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('span', {
    staticClass: "font-large"
  }, [_vm._v("Quick—")]), _vm._v("how long have you been imagining your wedding day? Even if you got engaged yesterday, chances are you’ve already got a few ideas to work with, and one or two (or twenty) wishes regarding the look and feel of the big event. Let’s not forget that you’re not marrying yourself—and your spouse-to-be will have ideas and wishes as well. And don’t leave out those friends and relations. (It’s the rare bride and groom who don’t get a healthy dose of input from well-meaning friends and family.) So when you’re ready to start planning, the trick is to sift through all the fabulous, maddening, endless, schizophrenia-inducing possibilities and zero in on how to build a wedding that’s absolutely right for you. In short, it’s time to Get Organized, which will help you Get Inspired, so you can bite the bullet and Get Moving.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01lev1sec1"
    }
  })]), _c('a', {
    attrs: {
      "id": "ch01lev1sec1"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("Get Organized")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("First things first: the most crucial piece of the DIY wedding-planning puzzle is figuring out what your resources are—monetary and otherwise—and how to allocate them. You can break the process into three distinct—but interdependent—chunks: set your budget, set your priorities, and set your team. How? Read on.")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "ch01lev1sec1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('strong', [_vm._v("Set Your Budget")])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("You’ve heard the jaw-dropping numbers: According to the most recent study by the Fairchild Bridal Group, the average cost of a wedding, "), _c('em', [_vm._v("not")]), _vm._v(" including big-ticket items like the engagement ring and the honeymoon, is above the $26,000 mark and climbing steadily. According to ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.TheWeddingReport.com",
      "target": "_blank"
    }
  }, [_vm._v("www.TheWeddingReport.com")]), _vm._v(", it’s more than $27,000. And everybody’s cashing in: wedding photography and videography are more than 100 percent more expensive now than they were in 1999, music costs are up by almost 70 percent, and flowers are up by almost 50 percent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The good news is that a DIY approach and conscious spending—including avoiding those wedding-specific vendors whose prices are skyrocketing—can help stem the rising tide and make the cost of the “average” wedding look ridiculously inflated. The trick is threefold: forget you ever heard those scary figures, set a budget that makes sense for "), _c('em', [_vm._v("you,")]), _vm._v(" and then consistently come in "), _c('em', [_vm._v("under")]), _vm._v(" it. Because here’s the worst news: nearly 50 percent of engaged couples wind up spending more than they originally budgeted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How can you avoid the pain of blowing your budget? First, be realistic when you build it. Though each wedding budget is unique, based on the bride’s and groom’s priorities and existing talent pool (here’s that interdependency thing I mentioned; more on both those topics in a moment), "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.TheKnot.com",
      "target": "_blank"
    }
  }, [_vm._v("www.TheKnot.com")]), _vm._v(" offers a good rough guide to the biggest-ticket items: reception expenses, including food and liquor, could account for up to 50 percent of your total cost, and attire, flowers, music, and photography could gobble up around 10 percent each. (I also highly recommend The Knot’s budgeting tool—it’s free, thorough, and easy to use.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But, of course, "), _c('em', [_vm._v("there are no absolutes,")]), _vm._v(" especially with a DIY wedding. One of the main principles of a smart, efficient DIY wedding—the very best kind—is that money spent and energy expended are inversely proportional. (See "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#figure-01"
    }
  }, [_vm._v("Figure A")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Here’s an example: You decide to go ahead and pony up for that gorgeous ready-to-wear dress you can’t get out of your head, thus freeing up multiple Saturday afternoons you would have spent trying to replicate it—searching for the perfect fabric, finding a seamstress, going to endless fittings. Presto—now you’ve got time to make your invitations and programs by hand, at little cost. Or, say your sister bakes like Julia Child "), _c('em', [_vm._v("and")]), _vm._v(" has a knack for doing flowers. Each task is equally time-consuming, but cake ingredients are readily available and cost very little, whereas nice flowers require some intrepid shopping and a moderately significant investment. So put your sister on oven duty, and pay someone else to do the flowers. In other words, you should only spend big when you don’t want to DIY, and, conversely, make sure that your DIY projects have minimal associated costs. It’s actually a good illustration of the “time is money” adage.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "figure-01"
    }
  })]), _c('a', {
    attrs: {
      "id": "figure-01"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("FIGURE A")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "figure-01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('strong', [_vm._v("This whole book is designed to save you money, so I won’t belabor the point, but here are some additional helpful hints:")])])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('p', {
    staticClass: "bullet"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('strong', [_vm._v("*")]), _vm._v(" When you’re just getting started, for a lark, go to ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.costofwedding.com",
      "target": "_blank"
    }
  }, [_vm._v("www.costofwedding.com")]), _vm._v(" and enter the zip codes of all the venues you’re considering. I can’t say it’s scientific, but it is entertaining—and it may give you a ballpark estimate of the cost difference between a wedding in a big city and one in a small town, or even the difference between weddings held in different neighborhoods in the same city.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('strong', [_vm._v("*")]), _vm._v(" When determining how much money you have to work with, approach all possible investors (parents, grandparents, long-lost uncles, sugar daddies) separately. Politely ask what they might be comfortable contributing, if anything. Asking this question may be awkward, but chances are they know it’s coming.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('strong', [_vm._v("*")]), _vm._v(" Take a good, hard look at your own savings. Decide how much you can step up the amount of money you’re setting aside every month. It’s wise to allocate 15 to 20 percent of each of your paychecks to a wedding fund from the day you get engaged.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('strong', [_vm._v("*")]), _vm._v(" Look into transferring some savings into a high-yield account or a six- or twelve-month CD. (Just make sure it matures in time to pay your vendors!)")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('strong', [_vm._v("*")]), _vm._v(" However, "), _c('em', [_vm._v("do not")]), _vm._v(" sink all your savings into this wedding. And don’t even think about going into debt. It really sucks to start your life together under the dark cloud of financial strain. If you’re tempted to use credit, make a list of all the things you might want to do in the year "), _c('em', [_vm._v("after")]), _vm._v(" the wedding—take trips, buy a home, get a dog, have a baby (eek!)—and imagine how it might feel to be unable to afford them. Think about how much better it would feel to go into married life feeling flush.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('strong', [_vm._v("*")]), _vm._v(" The more “real” quotes you get from vendors before creating your budget, the more accurate and useful that budget will be. When you have to estimate an expense, be generous, adding 10 to 15 percent on top of your initial guess.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "bullet"
  }, [_c('strong', [_vm._v("*")]), _vm._v(" Set aside 10 percent of your total budget for miscellaneous costs. Unexpected expenses will crop up, no matter how comprehensive your thinking is at the outset.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('strong', [_vm._v("*")]), _vm._v(" When you log expenditures, round up to the nearest five or ten dollars.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('strong', [_vm._v("*")]), _vm._v(" Adopt small savers’ tricks: Consider rounding up the amount you record in your check register to the nearest dollar every time you write a check or record a debit (for expenses wedding-related or otherwise), so a little padding begins to accumulate in your checking account. Start putting all your spare change into a jar to be converted into fun money for your honeymoon.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('strong', [_vm._v("*")]), _vm._v(" One quick way to decide if something is worth its lump-sum price is to determine the unit cost—just break every expense down into its smallest increment. For example, if a florist is asking for $3,000 to do the wedding party’s flowers, divide that by the number of bouquets and see if it’s a shocking figure. If a band wants $5,000 to play, divide that by the number of hours they’ll be playing. You can even divide the hourly rate by the number of guests, to see what your hourly cost of entertaining each guest will be.")]), _vm._v(" "), _c('h5', {
    staticClass: "h5"
  }, [_vm._v("Less Is More")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As you plan, the one thing you will fight over and over again is escalation: rising costs, a ballooning guest list, more and more bells and whistles and “extras.” I’ve yet to meet a bride and groom who say their wedding turned out smaller than they imagined.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("And although the best weddings do have a cohesive look and feel, that doesn’t necessarily mean “theme”—this isn’t a seven-year-old’s ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("birthday, or a sorority date party. It’s easy to lose sight of the simple, elegant little wedding in the midst of our current consumer frenzy, but remember that it’s fine if your “theme” is just “We’re getting married!” The venue you choose, the time of year, and you and your fiancé’s unique backgrounds, interests, and personalities make for plenty of mood-setting material. If you do articulate a theme, don’t worry it to death. Two or three notes are fine.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In general, "), _c('em', [_vm._v("use less.")]), _vm._v(" Do you really need confetti, birdseed, "), _c('em', [_vm._v("and")]), _vm._v(" butterflies? Do guests really need favors? As you’re faced with each new decision, decide whether you really need something or just "), _c('em', [_vm._v("think")]), _vm._v(" you need something because you saw it in a magazine, or at someone else’s wedding. It’s the party-planning equivalent of the time-honored fashion maxim: put on all your accessories and jewelry, then look in the mirror and take one thing off.")]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('em', [_vm._v("“WE DID” Advice From Real Couples")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("“Part of what we’re into is not just environmentalism, but sustainability and social responsibility. We’re pretty proud of the fact that our invitations were designed and printed by people we know, on 100-percent-recycled paper with soy-based ink, and we used reply postcards rather than cards with envelopes. My suit was made out of hemp, and on our Web site we asked guests not to buy anything new to wear to the wedding. Lots of people came up to Tybe to tell her that they’d honored our request. It’s hard to do something completely environmentally friendly in a place where most people are going to have to use cars, but we booked rooms at hotels nearby [the wedding venue] so most people stayed within a few minutes’ drive.”")])]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_c('strong', [_c('em', [_vm._v("—Judd Franklin, New York, on his Los Angeles wedding to wife Tybe")])])])]), _c('div', {
    staticClass: "sidebar"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('p', {
    staticClass: "sidehead"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Green Is the New White")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Let’s consider the planet for a minute. Go back to that “average” wedding cost. How much damage do you think you could do with $26,000? According to Climate Care, a British organization that sells carbon offsets, the average wedding emits around 14.5 tons of CO"), _c('sub', [_vm._v("2")]), _vm._v("—markedly more than the 12 tons emitted by the average person during a whole year. And then there’s the cost in trees, water, and fuel; pollution from things like printing and pesticides used on flowers; and the amount of waste sent to the landfill. DIY weddings, however, are generally easier on the environment. In each chapter, I’ll discuss specific ways to tread lightly, but here are some big-picture ideas:")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_vm._v("• Choose a nonprofit venue, such as a park or museum. We had our wedding at a lodge run by the National Arbor Day Foundation, a nonprofit organization dedicated to planting trees. Not only did every dollar of profit go toward greening the earth, but the facility itself was also very environmentally friendly: heating and cooling derived from wood chips burned on site; efficient plumbing and light fixtures; recycling bins in the rooms.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_vm._v("• Choosing any venue with inherently beautiful spaces—indoors or out—automatically saves money, resources, and CO"), _c('sub', [_vm._v("2")]), _vm._v(" emissions because the site needs little or no decoration.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_vm._v("• Have your ceremony and reception in the same place so guests don’t have to drive or be transported from one place to another. Even better, find a venue with ceremony space, reception space, and guest rooms all at the same facility, or within walking distance of one another. (Bonus points if the venue has airport shuttles so out-of-town guests needn’t bother renting cars.)")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_vm._v("• Think about the fuel costs and CO"), _c('sub', [_vm._v("2")]), _vm._v(" emissions that accompany destination weddings. Can you pick a place where a lot of your guests already live? If you choose a destination wedding, how eco-friendly is your venue? Strive for sustainable tourism.")])]), _c('p', {
    staticClass: "bullet1"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("• Borrow or rent anything and everything you can, instead of buying new. For attire and jewelry, go heirloom or vintage. If you’re buying a new dress or suit, organic cotton and hemp are the most responsible choices.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "bullet1"
  }, [_vm._v("• Choose organic and, ideally, locally grown food and flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_vm._v("• Choose wood-free or 100-percent-recycled paper products, and soy-based inks (like we did to print this book).")])]), _c('p', {
    staticClass: "bullet1"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("• Don’t use disposable plates, glasses, cutlery, or napkins unless absolutely necessary. If you must, buy renewable and/or bio-degradable products from a vendor like ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.greenhome.com",
      "target": "_blank"
    }
  }, [_vm._v("www.greenhome.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_vm._v("• Before you buy anything at all, from favors to bottles of water for your guests’ hotel-room goody bags, ask yourself, Will this end up in a landfill?")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_vm._v("• Consider contributing money toward carbon offsets for guests’ travel in lieu of favors—check out "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.gocarbonzero.org",
      "target": "_blank"
    }
  }, [_vm._v("www.gocarbonzero.org")]), _vm._v(" or "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.terrapass.com",
      "target": "_blank"
    }
  }, [_vm._v("www.terrapass.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_vm._v("• Register at small, local retailers for domestically made and environmentally friendly goods, or skip the registry altogether and tell guests “no gifts, please.” If you register through the I Do Foundation ("), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.idofoundation.org",
      "target": "_blank"
    }
  }, [_vm._v("www.idofoundation.org")]), _vm._v("), retailers will kick back a portion of sales to environmental (or other) charities of your choice. I went that route and was pretty happy with it, but I found myself feeling sheepish about the shipping: Before the gifts started arriving, I hadn’t considered the emissions from all those planes and trucks, or the excessive, wasteful packaging. Quite a recycling challenge!")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The best news is that, in many ways, what’s good for the environment is also good for your wallet, too—especially when it involves making do with less. For more ideas and information, go to "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.organicweddings.com",
      "target": "_blank"
    }
  }, [_vm._v("www.organicweddings.com")]), _vm._v(" or "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.portovert.com",
      "target": "_blank"
    }
  }, [_vm._v("www.portovert.com")]), _vm._v(".")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('strong', [_vm._v("Set Your Priorities")])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Deciding what’s most important to you is what makes your vision of your event begin to come to life. Your budget begins to crystallize, and the planning process cranks into gear. If you’re gaga for flowers, you clearly deserve a wedding filled with lush blooms. If you’re a stationery freak, then invites will be your “thing.” (Every bride has one . . . or two.) And so on and so forth—you know what you love. It’s usually harder to determine what’s less important, especially when you’re bombarded with messages from advertisers and vendors that make every little item seem vital. So I suggest breaking things out into three categories: high, medium, and low priority.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Here’s an example:")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Note that this list speaks only to your heart’s desire—not to how you might allocate your precious time and money. Your next step is to indicate which items on this list should get more of your money—the things that you or someone you know couldn’t satisfactorily provide under any circumstances—and which should get more of your time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But here’s the thing: You can’t possibly make such detailed notes until you’ve begun to tally up your existing resources (again, the interdependence). So, before you get too far into the planning process, you’ll want to round up the troops.")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('strong', [_vm._v("Set Your Team")])])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Remember, you’re not in this alone. DIY doesn’t mean you have to do it "), _c('em', [_vm._v("all")]), _vm._v(" yourself. It’s time to make a list of all the skills you have on tap, and put together your wedding “team.” If you expand your field of vision, you may find that you’ve got more to work with than you think. You know what your skills and interests are, and those of your spouse-to-be and your immediate families. Beyond that, think about all your friends, and all your networks, and your families’ networks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Is there a . . .")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FLORIST")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("JEWELRY DESIGNER")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GRAPHIC DESIGNER")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("WOODWORKER")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ARTIST")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MUSICIAN")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SEAMSTRESS")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DJ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BAKER")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTOGRAPHER")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CALLIGRAPHER")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CLERGYPERSON")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "righta"
  }, [_c('strong', [_vm._v(". . . in the house?")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Remember that a talented amateur can often work just as well as a professional. Don’t rule out anyone who could provide you with a high-quality service at a significantly reduced rate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now, keep thinking. Who are your downright crafty friends, the ones who are always good for ideas and/or manpower? The great cook, the friend with a knack for decorating, the pal with perfect penmanship? Do you know a hotel, motel, or bed-and-breakfast owner, or anyone who owns a fabulous piece of property that would make a good venue for the wedding? Make a list of anyone on whom you may be able to lean. Now match up your prioritized tasks with the resources you’ve assembled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As far as jobs for you and your spouse-to-be, now’s the time to pick whatever you naturally gravitate toward—whatever will give you the most pleasure and help you feel most connected to the wedding.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('strong', [_vm._v("Your annotated priority list might look like this:")])])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "high"
  }, [_c('strong', [_vm._v("High Priority")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RECEPTION VENUE")]), _vm._v(": Definitely want great urban setting with view. Check availability and cost of renting apartment roof deck and setting up tent for partial cover. If it’s out of the question, launch full search for locations with views. Willing to spend $ here.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTOS/VIDEO")]), _vm._v(": Best childhood friend Bill is a photojournalist. Pay for film and processing; hire separate videographer (need one who’s reasonably priced; ask Bill for referral).")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FOOD/LIQUOR")]), _vm._v(": Don’t want to bother. Hire great caterer. Can we buy our own liquor to cut costs? Make sure to tell caterer that our venue has no kitchen on site.")]), _vm._v(" "), _c('p', {
    staticClass: "medium"
  }, [_c('strong', [_vm._v("Medium Priority")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ATTIRE")]), _vm._v(": Attempt to find reasonably priced vintage cocktail dress. Excuse to shop! Buy new black suit for hubby-to-be. Make jewelry for bridesmaids and cuff links for groomsmen; these can double as gifts.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INVITATIONS")]), _vm._v(": Design and order ourselves, online. Hubby-to-be has great eye for design.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FLOWERS")]), _vm._v(": Sister offered to handle them—she can go for it. Work with her to establish reasonable budget.")]), _vm._v(" "), _c('p', {
    staticClass: "low"
  }, [_vm._v("Low Priority")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FAVORS")]), _vm._v(": Skip entirely")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CAKE")]), _vm._v(": Shoot for potluck sweets table (our moms’ friends will go crazy), accented by one or two items from caterer if necessary? Make sure caterers are ok with outside desserts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("At this point, you should have a decent idea of the helpers you’ll need to hire from outside your circle. Note: That doesn’t necessarily mean “professionals.” Throughout the book, I’ll give detailed suggestions for finding alternatives to traditional wedding vendors.")])]), _c('div', {
    staticClass: "sidebar"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('p', {
    staticClass: "sidehead"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("There Is No “Irate” in Team")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s vital to recruit helpers for your DIY wedding but with something this important, tensions can run high. So how do you make sure that your friends will still be speaking to you post-honeymoon?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First, don’t make assignments based on talent alone. Consider psychology and personality as well. For example, a friend who has trouble meeting deadlines probably should not be assigned to make the bridesmaids’ dresses. Make sure that the job you’re doling out is something the friend can handle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Keeping your expectations reasonable will go a long way toward maintaining your sanity. Try to stay as plugged in to reality as possible, and to stay in touch with the actual skill levels of the people who are working for you. (Going easy on the wedding magazines will help.) If you have a pet peeve or there’s something you definitely do not want—say, purple flowers in the bouquets—speak up at the outset, and reiterate it as you go along (nicely and respectfully, of course). And if the job you’re assigning is something big, create a schedule that includes check-ins along the way, so you can monitor progress. Nobody likes to be micromanaged, but everyone can use clear direction and support. (And no one can read your mind.) Tell your helpers you need them to complete their (nonperishable) tasks at least two weeks before you really need them done.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, make sure your team feels involved and appreciated every step of the way. When someone agrees to provide a service, send a handwritten note that says something like “Thank you so much for agreeing to photograph our wedding! We’re really excited to be working with you, and so thrilled that you will be an integral part of our important day.” On the wedding day, give your helper a small gift, as you would any other member of the wedding party, along with another handwritten note.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And if, goodness forbid, something turns out not at all the way you imagined, and it’s too late to make a change, grit your teeth, and be gracious. No snits.")])])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('strong', [_vm._v("Delegate, from Day One to Wedding Day")])])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Being a bride or groom is difficult enough if all you have to do is show up. Imagine how it will be if you’re also responsible for a huge to-do list that seems to get longer every day. If you’re the DIY type, be forewarned that, no matter how enthusiastic you are right now, you may want less and less to do with the planning and coordinating as the day draws near. So it’s crucial that you build in a support system that includes not only the people who have specific jobs but also a gang of willing and able generalists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the loveliest things about the DIY wedding is that there’s nobody but your nearest and dearest in your inner circle on the big day. But that doesn’t mean you don’t need the help that a wedding coordinator would provide. For this reason, it’s crucial that you ask your bridesmaids (if you have them) for support, and, more important, name a deputy—not your spouse, and nobody’s parent—who can make decisions and execute tasks for you, if need be, on the day before, the day of, and the day after the wedding. Choose someone with whom you communicate and work well, someone who will be able to tell when you need him or her to step in. Someone who will know when to bring something to your attention, and when to let you be. Someone whose taste and judgment you trust. This is a good job for a maid of honor, best man, sibling, or anyone else who is very close to you and would be happy to do the honors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But let me be clear: the fact that you have given someone a title doesn’t mean he or she automatically knows what you expect. Have a specific conversation in which you ask “Will you be my right hand?” Describe in detail the things you want this person to handle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Next, make a list of time- and labor-intensive tasks, from assembling invitations and favors in the months or weeks leading up to the wedding to decorating the reception space on the wedding day. Review the list of possible helpers that you created earlier, and add anyone else who’s expressed willingness to help out along the way. Remember that people being called up for duty should have ample notice.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('strong', [_vm._v("To make things run smoothly on the wedding day, and to ensure that you’re using all your volunteer resources, I suggest crafting a comprehensive document (and making copies for anyone whose name appears on it) that starts with the rehearsal, ends with any morning-after activities, and includes the following:")])])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "bulleta"
  }, [_c('strong', [_vm._v("*")]), _vm._v(" A schedule of what’s happening when. (Level of detail is up to you, but it will likely vary from, say, hour-long increments the morning of the wedding to fifteen- or thirty-minute increments during the wedding itself and the reception.)")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('strong', [_vm._v("*")]), _vm._v(" Notes on who’s taking care of each task.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('strong', [_vm._v("*")]), _vm._v(" Cell phone numbers for everybody.")])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("You’ll also encounter lots of on-the-spot volunteers—people who ask (with various degrees of sincerity), “How can I help?” Keep a running list of short-term tasks—such as pricing tent vendors, or looking for a particular color of ribbon—that you can hand out as necessary to the people who really mean it. Inevitably, no matter how organized you are, when you get down to the wedding weekend, you will still have lots of chores to do, and new ones popping up with every passing minute. Here’s a tip from one super-organized bride: Keep a stack of index cards and a marker on hand, and, as tasks crop up, write one on each card. Then, when volunteers ask what they can do, hand them a card and send them on their way! (Don’t forget to jot down what job you assigned to whom.) See “DIY Team Assignments” (")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch11#page_216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 216")]), _vm._v(") for a full list of jobs you may want to assign.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('p', {
    staticClass: "sidehead1"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("A WORD ABOUT CREATIVE SCUFFLES")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("When you’re getting wedding help from someone close to you on, say, designing an invitation or coming up with a floral scheme, communication can get tricky. Unlike in a traditional vendor/client relationship, you may not feel comfortable telling your pal to go back to the drawing board, especially if the work is very time consuming, and even more so if they’re doing it for you for free. But you may also be extra miserable if something is clashing with your vision of the big day. So, if you have strong opinions, it’s best to state them up front. If it’s your spouse-to-be you’re working with, communicate as clearly as you know how, and try to find a way to merge your two visions into something that works for both of you. If you find yourselves butting heads, there are two basic solutions: Compromise, or follow the “whoever cares more wins” school of thought..")])])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "paraspaceabove"
  }, [_c('em', [_vm._v("“WE DID” Advice From Real Couples")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("“He came home from work with a[n invitation] design. It was actually very cool, but modern—I was in a more traditional phase, and the feel didn’t match anything else in the wedding. Blame it on the stress of law school, or just my usual psychotic tendencies, but when he pulled it out to show me, I didn’t say a word. I just started crying. He just stared at me, probably wondering if he was making the right call in the whole marriage thing. The next day at work, he started working on the new design. He said his boss walked by and said, ‘I could have told you to go with the flowers the first time.’ Jason says I’m the only client he’s ever made cry. The second version, however, was beautiful.”")])]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_c('strong', [_c('em', [_vm._v("—Jill Robertson, San Francisco, on working with her graphic-designer husband, Jason")])])])]), _c('div', {
    staticClass: "sidebar1"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('p', {
    staticClass: "sidehead1"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("BEG, BARTER, OR STEAL")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s best not to ask for any favors that you can’t repay one way or another. Inner-circle contacts may do work for your wedding as a gift or at a substantial discount—though you never should assume they’re doing so. If you’re considering asking for a favor, take a second to make sure that it’s not out of line—if this person were asking the same of you, how would you feel? Whatever you do, don’t take advantage of anyone. One way to keep things even is to consider bartering: What good or service could you, or someone in your family, provide the other person in return? Among your friends—since groups of people tend to get married in packs—what can you do for one another? People are surprisingly open to bartering, if you ask.")])])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01lev1sec2"
    }
  })]), _c('a', {
    attrs: {
      "id": "ch01lev1sec2"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("Get Inspired")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "ch01lev1sec2"
    }
  }, [_vm._v("With your priorities straight, your resources identified, and your troops lined up, you can move on to the more creative stuff. A great way to begin to conjure the look and feel of your wedding is to create an inspiration board, or “mood” board. Designers (interior, fashion, graphic, all of ’em) use bulletin or magnetized boards full of images and words to bring concepts to life. For wedding planning, it’s a great place to compile all the colors, textures, and images that inspire you: magazine pages, invitations and stationery, paper samples, greeting cards, paint chips, photos, swatches of fabric. Display anything you love to look at that will help create an image in your mind. Because it hangs on your wall like a billboard, you can glance at it as you go ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("about your day. Ordinary moments at home morph into thinking and dreaming opportunities, and these may help you determine which of your ideas have “legs,” and what you might get bored with quickly. It’s an ever-evolving collage—just add what feels right, and take away what doesn’t. When it all seems to hang together, you’re ready to start planning.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine and dandy,” you say . . . “but I have a job, and a life, and now a million appointments and obligations related to this wedding, which is definitely not going to get planned by my staring at a wall.” Indeed. Which is why you might prefer a way to gather inspiration and information on the go. It’s too tedious to three-hole-punch everything (and too cumbersome to haul around a heavy binder), and it’s too easy for things to slip out of a file folder. So I suggest organizing your to-do lists, notes, bits of inspiration, and other wedding ephemera in a large (at least legal-sized), sturdy zippered envelope or pouch made out of vinyl or mesh. You can find them at the Container Store or office-supply stores. (The brand I used was Design Ideas.) Fill it up with everything from poems to postcards to matchbook covers, and purge often—once you’ve made a decision in a particular area, get rid of all the other options you’ve been hoarding.")])]), _c('div', {
    staticClass: "sidebar"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('p', {
    staticClass: "sidehead"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Magazine-Rack Racket")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Wedding magazines are (hopefully) a one-time phenomenon in your life; as such, you are entitled to as many as you can get your paws on. They certainly can be full of inspiration and ideas—some more so than others. But at a certain point, well, they can threaten to take over your home. To avoid clutter, and the classic “Where the &*$# did I see that?!” frustration, try “tear-sheeting” a magazine page the second you see something you love. Stick the torn-out pages on your inspiration board or tuck them into your pouch. Then recycle the rest of the magazine, or pass it on to a friend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But do consider that a steady diet of wedding mags can give even the most centered bride nervous indigestion. They’re the wedding industry’s most powerful tool for convincing you that you need things you really don’t. Remember that guests care more about seeing you and the groom happy than they do about tiny details.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For safety’s sake, I limited my consumption to the wedding bible: "), _c('em', [_vm._v("Martha Stewart Weddings.")]), _vm._v(" Of course, I flipped through plenty of other glossies at the newsstand, but I didn’t buy. You may notice, as I did, that after a while all wedding magazines start to look the same. In fact, I got just as much wedding inspiration from fashion, home decor, and travel magazines, which are equally good—or better—at bringing a mood to life, and they’re generally more exciting and evocative to boot.")])])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("Look and Feel")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Your wedding’s personality is going to emerge and evolve with each decision you make. But right now, before you get anywhere near the sign-on-the-dotted-line stage, is the time to step back and imagine all the different scenarios that could make you happy. I’m sure you’re doing that automatically—your mind probably started drifting toward possible venues the minute that ring landed on your finger. But take your time, and think it through. Should it be indoors or out? Casual or fancy? Will you greet your guests on the beach, ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("on a mountaintop, or in a vineyard? Will the event be inspired by a beloved place, or an annual event? A hometown, or an adopted city? A shared hobby or profession? A cultural heritage, or just a culture you admire?")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Our wedding was very simple and didn’t have anything I’d call a “theme,” so we relied heavily on the simple beauty of the outdoors, and the power of color, manifested in our wedding party’s attire and our flowers. When you’re prowling around for inspiration, color is an excellent avenue to wander down. What colors make you ecstatically happy? What colors remind you of places you love? A caveat, though: while some brides get as attached to their “colors” as a high-school cheerleader might, adopting a more flexible attitude is going to net you a better-looking wedding, with more visual depth. It’s best to avoid a style that’s too “matchy,” with every last detail coordinated, and also a look that’s too “mixy,” with too many dissonant colors. Pick whatever you like, but make sure it works with, not against, the setting and that it makes sense for the season. The best place to see all the colors in the rainbow—and make off with samples—is the paint display at a hardware store. You can comb the samples to your heart’s content and take them home to live with them for a while. (Fabric stores are good for inspiration too.) If you need to communicate color information to faraway friends or wedding-party members, mail them the appropriate paint chips. Don’t rely on how things look online—the colors you see on a computer screen aren’t true to life.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01lev1sec3"
    }
  })]), _c('a', {
    attrs: {
      "id": "ch01lev1sec3"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("Get Moving")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now that you’ve built an image of the big day in your head, it’s time to make the big decisions: roughly how many people will attend, where it will take place, and when it will happen. All your other planning decisions will flow from these three choices, which are, yep, "), _c('em', [_vm._v("interdependent.")])])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "ch01lev1sec3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('strong', [_vm._v("The People")])])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s smart to rough out an ideal guest list as early as possible—and prepare to haggle over it until the day the invitations go in the mail. Kidding! (Sort of.) Make a list of people you "), _c('em', [_vm._v("must")]), _vm._v(" invite and another list of people you’d "), _c('em', [_vm._v("like")]), _vm._v(" to invite. Gather preliminary lists of names from your families as soon as possible. Consider costs and the impact on the wedding’s vibe as your numbers grow. Obviously, the smaller the wedding, the easier it is to DIY. Two hundred guests is probably the upper limit for an event you’re going to pull off with a minimum of professional help.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s always tricky to estimate how many of the invited guests will show up. I’ve seen estimates ranging from 50 to 90 percent, depending on too many factors to name. But the best general rule I’ve encountered is that you’ll have roughly as many guests as the number of envelopes you address. Old wedding coordinators’ tale? Complicated statistical analysis? Beats me, but it works. With our wedding, it was too low by 20 people—what I’d call the outside edge of an acceptable margin of error. But it gave us a decent number to work with until we started getting real data.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("The Place")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Picking the right setting is the best thing you can do for your wedding. A place that is gorgeous when empty is only going to get more so when it’s filled with an ecstatic bride and groom and their merry guests. Plus, the better it looks on its own, the less you need to adorn it, which means less work and less expense. Consider a foolproof natural setting—a forest, mountaintop, lakeside dock, or beach. Or, if you don’t want to stress about the weather, a restaurant, club, or loft with big windows and great views of water, sunset, or city skyline. If you’re getting married around the holidays, consider someplace that will already be tastefully decorated with greenery and lights. The possibilities are endless. Just keep your eyes open ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("when you go to look at possible venues and see how “turnkey” they are: could you just walk in and have the wedding there tomorrow?")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Do consider that where you choose to have the wedding may influence how much you can DIY. Many venues require you to use their own catering and/or bar services. And, since you and your team may be doing a lot of the setup, you’ll want to inquire about access to the venue before your event. You don’t want to be arranging centerpieces twenty minutes before the ceremony.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Also, try to at least have a ballpark number of guests in mind before you begin your venue search so you don’t go falling in love with something that’s too small or too big.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And one final thing to consider: good lighting is absolutely key to a great event. That doesn’t mean that you need to hire a lighting designer, but when you’re scoping venues, do note a few things: How much natural light does the space get? From which directions? Is the overhead lighting flattering? Flexible? Are the lights on dimmers? Can you provide your own lighting instead? If portions of the event will take place outside, when’s sunrise/sunset/moonrise on the dates you’re considering? What phase will the moon be in the day you’re thinking of getting married? (A full moon adds a magical—and wild—touch to a wedding.) You can find all this information on the Web. If possible, visit all of your possible venues at the hours you’d be using them to get a true picture of the lighting.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("The Date")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Have you had a target month or day in mind from the minute you got engaged? Great—but try to be flexible. When you find a venue you like, inquire immediately about availability. If you have the luxury of choice, work with the seasons, choosing the time of year that best flatters your venue. Don’t be shy about asking questions, such as “Can you show me pictures of past winter weddings?” “How late does it stay warm in the fall?” “What’s going to be blooming in May, and ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("in what colors?” “What’s this bush over here, and how will it look on my wedding day?” Ideally, nature will set a beautiful stage for your wedding, with related color choices, flowers, and menu all flowing from the look of your wedding venue on the day you wed. The bonus: you’ll get higher quality at a lower price when you use flowers and food in season, and it’s better for the environment that way, too.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Make sure you ask all the major players about their availability before you set a date. That means both families (parents and siblings), and anyone whom you’re going to ask to be in your wedding party. If you must have a certain officiant (more on that in ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")]), _vm._v("), you’ll also want to check with that person. Keep holidays, big days like the Super Bowl, and peak airfare times in mind. Weddings on weeknights, Fridays, and Sundays are gaining in popularity, and they can certainly save you money, but they may ratchet up the expenses for your guests, since they may have to take time off work and incur extra hotel costs. Ask yourself, “If I were a guest at this wedding, is there anything about the scheduling or timing that would annoy me?” When you weigh all the factors, you may conclude that Saturday is still the best day for a wedding. To cut costs, consider Saturday morning or afternoon instead of the evening, or early enough on Sunday so people can travel home afterward.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, before you sign on the dotted line for a particular venue, be sure to take any disabled or elderly guests into account. Think about it in both macro (is there anyone important for whom travel is difficult?) and micro (how accessible are the ceremony and reception spaces, and what kind of travel is required to get from one to the other?) terms.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "ch01lev1sec4"
    }
  })]), _c('a', {
    attrs: {
      "id": "ch01lev1sec4"
    }
  }), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch01lev1sec4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('strong', [_vm._v("Deep Breath: Pat Yourself on the Back")])])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whew—what a process! Did you ever imagine it would be this complicated? It’s simply exhausting to hold all these interlocking variables in your mind. But look at everything you’ve accomplished: You’ve set your priorities, assembled your DIY team, secured your venue, established your wedding date, determined the broad strokes of your budget, and maybe locked in the cost of your venue, if applicable. "), _c('em', [_vm._v("You may have even sent in a deposit.")]), _vm._v(" (Holy crap! It’s happening!) These are "), _c('em', [_vm._v("huge")]), _vm._v(" accomplishments. I promise that these early decisions really are the bulk of your wedding work—the intellectual and psychological work, anyway, which are the hardest kinds—and that your discipline and coordination here will pay off later. Now you can begin to fill in the rest of your budget numbers and sail on toward the fun stuff. But, before you proceed, take a moment to celebrate with your fiancé. (It’d make a nice antidote if, you know, you might happen to be having any little disagreements or slightly fraught conversations or anything like that. Just in case.) Splurge on a nice dinner. Pop open a bottle of bubbly. And breathe.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba0ebdb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Ch01.vue
// module id = 81
// module chunks = 0